import {ForgotCredentialsExternalLinkHandlerBase} from "../forgot-credentials-external-link-handler-base";
import {IForgotPasswordExternalLinkHandler} from "./forgot-password.external-link-handler.interface";
import {GNWP_SOURCES} from "../../../../gnwp/gnwp-consts";
import {ExternalLinkInIframeRendererParams} from "../../external-link-in-iframe-handler-base";
import {CyClass} from "../../../../../../common/cy-classes";

export class ForgotPasswordExternalLinkHandler extends ForgotCredentialsExternalLinkHandlerBase implements IForgotPasswordExternalLinkHandler {
    protected _getGnwpSource(): GNWP_SOURCES {
        return GNWP_SOURCES.FORGOT_PASSWORD;
    }

    async openForgotPassword(): Promise<void> {
        const url = await this._getGnwpUrl();
        await this._showExternalLinkDialog(url);
    }

    protected async _getGnwpUrl(): Promise<string> {
        return await this.services.gnwp.getForgotPasswordUrl();
    }

    protected _getIframeRendererParams(): ExternalLinkInIframeRendererParams {
        return {
            ...super._getIframeRendererParams(),
            iframeExtraCssClass: CyClass('cy-forgot-password-external-link-container')
        };
    }
}